<template>
  <div style="width: 90%; display: inline-block;">
    <div class="title-sy"><span style="border-bottom: 1px solid rgb(124, 185, 186);">{{ proTitle }}</span></div>
    <el-row class="div-middle-all">
      <div v-if="imgAlign == 'left'">
        <el-col :span="14">
          <el-image :src="imgProSrc" style="height: 430px"></el-image>
        </el-col>
        <el-col :span="9" style="text-align: left;margin-left: 20px;height: 430px;display: table;">
          <div v-html="proText" style="display: table-cell;vertical-align: middle;"></div>
        </el-col>
      </div>
      <div v-else-if="imgAlign == 'right'">
        <el-col :span="9" style="text-align: left;margin-right: 20px;height: 430px;display: table;">
          <div v-html="proText" style="display: table-cell;vertical-align: middle;"></div>
        </el-col>
        <el-col :span="14">
          <el-image :src="imgProSrc" style="height: 430px"></el-image>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "ProfilePlugin",
  props: {
    proTitle: {
      type: String
    },
    imgAlign: {
      type: String,
      default: 'left'
    },
    imgProSrc: {
      type: String
    },
    proText: {
      type: String
    }
  },
  data() {
    return {
    }
  }
}
</script>

<style scoped>
</style>
